import {
    Box, Button, Checkbox,
    DialogActions, DialogContent,
    DialogTitle, Divider, FormControl,
    FormControlLabel, FormGroup,
    FormHelperText, InputAdornment,
    InputLabel, MenuItem, Select,
    TextField, Typography,
    Unstable_Grid2 as Grid
} from "@mui/material"
import { useForm } from "react-hook-form"
import { LoadingButton } from "@/components/common/LoadingButton";
import { FormTextField } from "@/components/HookForm";
import { dialogClose, dialogOpen } from "@/modules/MuiDialog";
import { toast } from "react-toastify";
import { patchMallBusinessInfo, patchMallInfo } from "@/services/mall.service";
import { banks } from "@/constant/banks";
import { useRef, useState } from "react";
import SquareThumbInput from "@/components/FileInput/SquareThumbInput";
import { uploadImageToStorage } from "@/services/proxy.service";
import SearchAddressDialog from "@/pages/dialogs/SearchAddressDialog";
import DialogTitleBox from "@/modules/MuiDialog/DialogTitleBox";
import { useTranslation } from "react-i18next";

interface ReturnAddressInfoType {
    postCode?: string,
    recipientAddress?: string,
    recipientAddressDetail?: string;
    returnShippingCost?: string;
    returnAddressName?: string;
    returnAddressTel?: string;
}
interface ReturnAddressInfoDialogProps extends ReturnAddressInfoType {
    mallId: string;
}

export const ReturnAddressInfoDialog = (props: ReturnAddressInfoDialogProps) => {
    const { t } = useTranslation();
    const form = useForm<ReturnAddressInfoType>({
        defaultValues: {
            postCode: props?.postCode || '',
            recipientAddress: props?.recipientAddress || '',
            recipientAddressDetail: props?.recipientAddressDetail || '',
            returnShippingCost: props?.returnShippingCost,
            returnAddressName: props?.returnAddressName || '',
            returnAddressTel: props?.returnAddressTel || '',
        }
    })
    const {
        register, watch, setValue,
        handleSubmit, trigger,
        formState: { isValid, isDirty, errors, isSubmitting }
    } = form;

    const searchAddrBtnRef = useRef<HTMLButtonElement>(null);
    async function formSubmit(data: any) {
        try {
            await patchMallInfo(props.mallId, { mallReturnAddressInfo: { ...data } })
            toast.success(t('common.updated'))
            dialogClose()
        } catch (error) {
            toast.error(t('mall.updateFailedTemporary'))
            throw error
        }
    }
    return (
        <>
            {/* <DialogTitle>반품지 주소 설정</DialogTitle> */}
            <DialogTitleBox title={t('mall.returnAddressSettings')} />
            <DialogContent>
                <Grid container>
                    <Grid xs={12}>
                        <TextField
                            fullWidth
                            required
                            label={t('mall.postalCode')}
                            value={watch().postCode}
                            onClick={() => {
                                if (!!searchAddrBtnRef.current) searchAddrBtnRef.current.click();
                            }}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Button
                                            variant={'contained'}
                                            ref={searchAddrBtnRef}
                                            onClick={ev => {
                                                ev.stopPropagation();
                                                dialogOpen({
                                                    innerElement: (
                                                        <SearchAddressDialog
                                                            onComplete={data => {
                                                                try {
                                                                    if (!data) return;
                                                                    const { zonecode, address, jibunAddress, userSelectedType } = data
                                                                    setValue('postCode', zonecode, { shouldDirty: true, shouldValidate: true })
                                                                    setValue(
                                                                        'recipientAddress',
                                                                        userSelectedType === 'J'
                                                                            ? jibunAddress
                                                                            : address,
                                                                        { shouldDirty: true, shouldValidate: true })
                                                                } catch (error) { throw error }
                                                            }}
                                                        />
                                                    ),
                                                    PaperProps: {
                                                        sx: {
                                                            backgroundColor: 'transparent',
                                                            elevation: 0
                                                        }
                                                    }
                                                })
                                            }}
                                        >
                                            {t('mall.searchPostalCode')}
                                        </Button>
                                    </InputAdornment>
                                )
                            }}
                        />
                        <TextField
                            label={t('mall.address')}
                            placeholder={t('mall.enterPostalCode')}
                            value={watch().recipientAddress}
                            InputProps={{ readOnly: true }}
                            required
                            fullWidth
                        />
                        <FormTextField
                            label={t('mall.detailedAddress')}
                            name={'recipientAddressDetail'}
                            form={form}
                            formTrigger={'change'}
                            defaultValue={''}
                            placeholder={t('mall.enterDetailedAddress')}
                            fullWidth
                        />
                        <FormTextField
                            label={t('mall.returnAddressName')}
                            name={'returnAddressName'}
                            form={form}
                            formTrigger={'change'}
                            defaultValue={''}
                            placeholder={t('mall.enterReturnAddressName')}
                            fullWidth
                        />
                        <FormTextField
                            label={t('mall.returnAddressPhone')}
                            name={'returnAddressTel'}
                            form={form}
                            formTrigger={'change'}
                            defaultValue={''}
                            placeholder={t('mall.enterReturnAddressPhone')}
                            fullWidth
                        />
                        <FormTextField
                            sx={{ m: 0 }}
                            form={form}
                            // type="number"
                            name="returnShippingCost"
                            label={t('mall.returnShippingCostOneWay')}
                            fullWidth
                            InputProps={{
                                startAdornment: <InputAdornment position="start">₩</InputAdornment>
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <LoadingButton
                    isLoading={isSubmitting}
                    disabled={!isValid || !isDirty}
                    onClick={async () => { await handleSubmit(formSubmit)() }}
                >{t('common.edit')}</LoadingButton>
                <LoadingButton color={'error'} onClick={() => { dialogClose() }}>{t('common.cancel')}</LoadingButton>
            </DialogActions>
        </>
    )
}